import { render, staticRenderFns } from "./verify-code.vue?vue&type=template&id=b5547802&scoped=true&"
import script from "./verify-code.vue?vue&type=script&lang=js&"
export * from "./verify-code.vue?vue&type=script&lang=js&"
import style0 from "./verify-code.vue?vue&type=style&index=0&id=b5547802&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5547802",
  null
  
)

export default component.exports